const locale = {
	pageTitle: 'CNC Precision Machined Products | QingYi Precision',
	pageDesc: 'Browse QingYi Precision\'s Swiss-type CNC machined parts gallery. Cincom L20 machined φ1–20mm components including shafts, screws, bushings, connectors in stainless steel, aluminum, brass, and titanium.',
	pageKeywords: 'CNC machined products, Cincom L20, Swiss-type lathe, small-diameter parts, shaft machining, screw machining, bushing machining, connector machining, medical parts, aerospace parts, Taiwan precision machining',
	title: 'Precision Machined Products',
	subtitle: 'CNC Turned & Milled Parts Gallery',
	catAll: 'All',
	catShaft: 'Shafts & Pins',
	catScrew: 'Screws & Fasteners',
	catBushing: 'Bushings',
	catConnector: 'Connectors',
	catPlate: 'Plates',
	catComplex: 'Complex Parts',
	catWorm: 'Worm Gears',
	matSus: 'SUS',
	matBrass: 'Brass',
	matCopper: 'Copper',
	matAlu: 'ALU',
	matTi: 'Ti',
	matPlastic: 'Plastic',
	dialogTitle: 'QingYi Precision Co., Ltd.',
};

export default locale;
